import Vue from "vue";
import { mapGetters, mapMutations, mapState } from "vuex";

import ImpressaoComponent from "@/components/child/impressao/impressaoComponent";
import impressaoComponent from "@/components/child/impressao/impressaoComponent.vue";
import loadingModalComponent from "@/components/child/loadingmodal/loadingmodal.vue";
import ManipulacaoLoteEstoqueComponent from "@/components/parent/manipulacaoNew/lotesEstoque/loteEstoque";
import manipulacaoLoteEstoqueComponent from "@/components/parent/manipulacaoNew/lotesEstoque/loteEstoque.vue";
import { Component } from "@/decorators";
import DestinoManipulacao from "@/models/enum/destinosManipulacao";
import { default as ManipulacaoOrdemModel, StatusEstoqueManipulacao } from "@/models/manipulacaoOrdemModel";
import UsuarioModel from "@/models/usuarioModel";
import ManipulacaoService from "@/services/manipulacaoOrdemService";
import ReceitaArquivoService from "@/services/receitaArquivoService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { FastActionLastPack, FastActionList, FastActionPack } from "@/store/fastActionStore";
import { AppState, Getters, Mutations, SessionActions } from "@/store/store";
import Delay from "@/utils/common/delay";

import ShortcutComponent from "./../../../shortcut/shortcut";
import shortcutComponent from "./../../../shortcut/shortcut.vue";
import ManipulacaoListComponent from "./list";
import manipulacaoListComponent from "./list.vue";

import "./../fastactionsgrid.scss";

@Component({
    components: {
        loadingModalComponent,
        shortcutComponent,
        manipulacaoLoteEstoqueComponent,
        manipulacaoListComponent,
        impressaoComponent,
    },
    computed: {
        ...mapState({
            fastActionLists: (state: AppState) => state.fastAction.fastActionLists,
            fastActionPack: (state: AppState) => state.fastAction.fastActionPack,
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["VALIDAR_PERMISSAO_USUARIO"] as Getters),
    },
    methods: {
        ...mapMutations(["SET_LISTSPACK", "SET_LASTCOUNTPACK", "LOAD_COUNTPACK", "CLEAR_LISTVENDA"] as Mutations),
    },
})
export default class FastActionManipulacaoPanelComponent extends Vue {
    // State computed props
    fastActionLists: FastActionList;
    fastActionPack: FastActionPack;
    usuarioLogado: UsuarioModel;
    SET_LISTSPACK: (data: FastActionList) => void;
    SET_LASTCOUNTPACK: (data: FastActionLastPack) => void;
    LOAD_COUNTPACK: () => void;
    CLEAR_LISTVENDA: () => void;
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;

    private manipulacoes: Array<ManipulacaoOrdemModel> = [];
    private shortCutLote: ShortcutComponent = null;

    private shortCutList: ShortcutComponent = null;
    private manipulacaoLoteEstoqueComponent: ManipulacaoLoteEstoqueComponent = null;
    private manipulacaoListComponent: ManipulacaoListComponent = null;
    private impressaoComponent: ImpressaoComponent = null;

    private service = new ManipulacaoService();
    private receitaArquivoService = new ReceitaArquivoService();

    private loadManipulacaoListComponent = false;

    private model: ManipulacaoOrdemModel = null;

    unidadeMedidasOptions: Array<Object> = [];

    private getClass(manipulacao: ManipulacaoOrdemModel) {
        manipulacao.destino == DestinoManipulacao.Venda;
        switch (manipulacao.statusEstoque) {
            case StatusEstoqueManipulacao.NaoVerificado:
                return "";
            case StatusEstoqueManipulacao.Divergente:
                return "ExcRed";
            case StatusEstoqueManipulacao.Conferido:
                return "ExcGreen";
            default:
                return "";
        }
    }

    private getTitle(manipulacao: ManipulacaoOrdemModel) {
        switch (manipulacao.statusEstoque) {
            case StatusEstoqueManipulacao.NaoVerificado:
                return this.$t("__.ts.estqNaoVerif") as string;
            case StatusEstoqueManipulacao.Divergente:
                return this.$t("__.ts.estqQtdBaixaDiverg") as string;
            case StatusEstoqueManipulacao.Conferido:
                return this.$t("__.ts.estqVerif") as string;
            default:
                return this.$t("__.ts.estqAindaNaoVerif") as string;
        }
    }

    private async onVerMais() {
        this.model = null;
        this.loadManipulacaoListComponent = true;

        while (!this.$refs.shortCutList) await Delay(5);
        this.shortCutList = this.$refs.shortCutList as ShortcutComponent;

        while (!this.$refs.manipulacaoListComponent) await Delay(5);
        this.manipulacaoListComponent = this.$refs.manipulacaoListComponent as ManipulacaoListComponent;

        this.shortCutList.title = this.$t("__.ts.manipulacoes") as string;
        this.shortCutList.show();
    }

    private onSearch(manipulacao: ManipulacaoOrdemModel) {
        this.$router.push("/manipulacaoordem-edicao/" + manipulacao.id);
    }
    private async onLote(manipulacao: ManipulacaoOrdemModel) {
        this.model = null;
        await this.load(manipulacao.id);

        while (!this.$refs.shortCutLote) await Delay(5);
        this.shortCutLote = this.$refs.shortCutLote as ShortcutComponent;

        while (!this.$refs.manipulacaoLoteEstoqueComponent) await Delay(5);
        this.manipulacaoLoteEstoqueComponent = this.$refs
            .manipulacaoLoteEstoqueComponent as ManipulacaoLoteEstoqueComponent;

        this.shortCutLote.title = this.$t("__.ts.lotesEstqManipul") as string;
        this.manipulacaoLoteEstoqueComponent.loadModel(
            this.model.estoqueId,
            this.model.movimentacaoEstoqueId,
            this.model.id,
        );
        this.shortCutLote.show();
    }

    private async onCloseLote() {
        this.shortCutLote.hide();
    }

    private async loadManipulacoes(forceLoad = false) {
        if (this.fastActionLists.manipulacoes.length > 0 && !forceLoad) {
            this.manipulacoes = this.fastActionLists.manipulacoes;
        } else {
            //salva as conferidas para nao atualizar a tela sem refazer conferencia de estoque
            let manipulacoesConferidas = new Array<ManipulacaoOrdemModel>();
            if (this.manipulacoes.length > 0) {
                manipulacoesConferidas = this.manipulacoes.filter(
                    p => p.statusEstoque != StatusEstoqueManipulacao.NaoVerificado,
                );
            }
            try {
                this.manipulacoes = await this.service.listManipulacaoHome().resolveWithJSON<ManipulacaoOrdemModel[]>();

                //atualiza as manipulacoes com os status das conferidas
                if (manipulacoesConferidas.length > 0) {
                    for (let i = 0; i < manipulacoesConferidas.length; i++) {
                        if (this.manipulacoes.some(p => p.id == manipulacoesConferidas[i].id)) {
                            this.manipulacoes.find(p => p.id == manipulacoesConferidas[i].id).statusEstoque =
                                manipulacoesConferidas[i].statusEstoque;
                        }
                    }
                }
                this.SET_LISTSPACK({ manipulacoesAConcluir: this.manipulacoes });
            } catch {}
        }
    }

    private async load(id = 0) {
        this.model = new ManipulacaoOrdemModel();

        if (id > 0) {
            try {
                const data = await this.service.get(id).withLoading().resolveWithJSON<ManipulacaoOrdemModel>();
                this.model.updateFrom(data);
            } catch {}
        }
    }

    public async onImprimirRotulo(manipulacao: ManipulacaoOrdemModel) {
        await this.impressaoComponent
            .show({
                modelId: manipulacao.id,
                tipoImpressao: "Manipulacao",
            })
            .withLoading();
    }

    public async onExibirReceita(manipulacao: ManipulacaoOrdemModel) {
        await this.receitaArquivoService.showFiles(manipulacao.receitas);
    }

    public async onImprimirManipulacaoModelo(manipulacao: ManipulacaoOrdemModel) {
        await this.impressaoComponent
            .show({
                modelId: manipulacao.id,
                tipoImpressao: "Manipulacao",
                impressaoRotulo: false,
                impressaoSelecionarModelo: true,
            })
            .withLoading();
    }

    private async onConcluirManipulacao(manipulacao: ManipulacaoOrdemModel) {
        if (this.model == null || this.model.id != manipulacao.id) {
            await this.load(manipulacao.id);
        }

        try {
            const sucesso = await this.service.Concluir(this.model).withLoading().resolveWithoutJSON();
            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.concl"), this.$t("__.ts.manipuConclSucesso"));

                if (this.loadManipulacaoListComponent && this.shortCutList.isShowing()) {
                    if (this.manipulacaoListComponent != null) {
                        this.manipulacaoListComponent.load();
                    }
                }
                this.loadManipulacoes(true);
                //diminui 1 manipucao
                const manipulacoesAConcluir = Number(this.fastActionPack.countPack.manipulacoesAConcluir) - 1;
                //limpa vendas para refazer ao entrar nelas caso tenha alterado algo
                this.CLEAR_LISTVENDA();
                this.SET_LASTCOUNTPACK({ manipulacoesAConcluir });
                this.LOAD_COUNTPACK();
                //pode ser que aqui aumente a venda, se tds manipulacoes da venda estiverem concluidas
                //setar a venda para false para forcar o reload e refazer o count principal
                //todo: verificacao da venda desta manipulacao apenas
            }
        } catch {}
    }

    private getVerificados() {
        return this.manipulacoes.filter(
            p => p.statusEstoque != null && p.statusEstoque != StatusEstoqueManipulacao.NaoVerificado,
        ).length;
    }

    private onConfirmList() {
        this.shortCutList.hide();
    }

    private validarVisibilidadeBotao(acao: string) {
        return this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", acao);
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        this.shortCutLote = this.$refs.shortCutLote as ShortcutComponent;
        this.impressaoComponent = this.$refs.impressaoComponent as ImpressaoComponent;

        const response = await Promise.all([
            unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId),
            this.loadManipulacoes(false),
        ]);
        this.unidadeMedidasOptions = response[0];

        this.SET_LASTCOUNTPACK({
            manipulacoesAConcluir: Number(this.fastActionPack.countPack.manipulacoesAConcluir),
        });
    }
}
